module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: {
        'is-active': tab.isActive
      }
    }, [_c('a', {
      domProps: {
        "innerHTML": _vm._s(tab.header)
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(tab)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tab.name) + "\n        ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tab-details"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a50344fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/tabParentComponent.vue
// module id = 382
// module chunks = 5